import React from "react";

import { ButtonView } from "common/views/button/Button.view";
import { ImageView } from "common/views/image/Image.view";
import PageLinkView from "common/views/pageLink/PageLink.view";
import ProgressBarView from "common/views/progressBar/ProgressBar.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import ProgramTrack from "panels/catalog/entities/ProgramTrack";
import ProgramLabels from "panels/catalog/Program.labels";


interface IProgramTrackDisplayProps {
	renderTrackCourses: (track: ProgramTrack) => JSX.Element;
	track: ProgramTrack;
}

export const title: Fragment<IProgramTrackDisplayProps> = {
	name: "Title",
	component: ({track}) => (
		<TypographyView viewKey="programTrack.title">
			<Label k={`ProgramTrack.${track.id}.name`} v={track.name} />
		</TypographyView>
	)
};

export const description: Fragment<IProgramTrackDisplayProps> = {
	name: "Description",
	component: ({track}) => (
		<TypographyView viewKey="programTrack.description" html={track.description} />
	)
};

export const progress: Fragment<IProgramTrackDisplayProps> = {
	name: "Progress",
	component: ({track}) => (
		<ProgressBarView
			viewKey="programTrack.progress"
			value={
				track.progress &&
				track.progress.total > 0 &&
				((track.progress.completed || 0) / track.progress.total) ||
				0
			}
		/>
	)
};

export const icon: Fragment<IProgramTrackDisplayProps> = {
	name: "Icon",
	component: ({track}) => (
		<ImageView viewKey="programTrack.icon" src={track.trackIconURL} />
	)
};

export const requirements: Fragment<IProgramTrackDisplayProps> = {
	name: "Requirements",
	enabled: ({track}) => !!track.progress && track.progress.total > 0,
	component: ({track}) => (
		<div>
			<ProgramLabels.Labels.Progress args={{completed: track.progress.completed, total: track.progress.total}} />
		</div>
	)
};

export const view: Fragment<IProgramTrackDisplayProps> = {
	name: "View Track Details",
	component: ({track}) => (
		<PageLinkView params={{programTrackId: track.id}} viewKey="programTrack.view">
			<ButtonView viewKey="programTrack.view.button">
				<ProgramLabels.Labels.TrackView />
			</ButtonView>
		</PageLinkView>
	)
};

export const courses: Fragment<IProgramTrackDisplayProps> = {
	name: "Courses",
	enabled: ({renderTrackCourses}) => typeof renderTrackCourses === 'function',
	component: ({track, renderTrackCourses}) => renderTrackCourses(track)
};



// WEBPACK FOOTER //
// ./src/panels/catalog/fragments/programTrack/displayFragments.tsx